import { checkIcon, closeIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/quiz_answer.module.scss'

interface IProps {
  answerNumber: string | number
  correctAnswer: string
  isAswerCorrect: boolean
  question: string
  userAnswer: string
}

const QuizAnswersCard = ({
  answerNumber,
  correctAnswer,
  isAswerCorrect,
  question,
  userAnswer
}: IProps): React.ReactElement => {
  // const isCorrect = correctAnswer === userAnswer;

  return (
    <div
      className={classNames({
        [style.quiz]: true,
        [style.quiz_correct]: isAswerCorrect
      })}
    >
      <span
        className={classNames({
          [style.quiz__number]: true,
          [style.quiz__number_correct]: isAswerCorrect
        })}
      >
        {answerNumber}
      </span>

      <div className={style.quiz_answers}>
        <p className={style.quiz__question}>{question}</p>
        {isAswerCorrect
          ? (
            <p className={style.quiz__answer}>{correctAnswer}</p>
            )
          : (
            <>
              <p className={style.quiz__answer_user}>
                Твой ответ:<span>{userAnswer}</span>
              </p>
              <p className={style.quiz__answer_correct}>
                Правильный ответ:<span>{correctAnswer}</span>
              </p>
            </>
            )}
      </div>

      <GxIcon
        src={isAswerCorrect ? checkIcon : closeIcon}
        className={classNames({
          [style.quiz__icon]: true,
          [style.quiz__icon_correct]: isAswerCorrect
        })}
      />
    </div>
  )
}

export default QuizAnswersCard
